type PopulationType = {
  populate: string[]
}

export const PopulationParam: PopulationType = {
  populate: [
    'Items',
    'Items.Links',
    'Items.Buttons',
    'Items.Buttons.BackgroundImage',
    'Seo',
    'Seo.MetaAttributes',
    'Seo.MetaImage',
    'Hero',
    'Hero.FeatureImage',
    'Hero.Icons',
    'Hero.Icons.Image',
    'Hero.Buttons',
    'Hero.BrandButtons',
    'Hero.BrandButtons.BackgroundImage',
    'Hero.BrandButtons.Icon',
    'Hero.CarouselImages',
    'Hero.AppStoreButtons',
    'Hero.AppStoreButtons.BackgroundImage',
    'Hero.AppStoreButtons.Icon',
    'Hero.CustomerReviews',
    'Hero.CustomerReviews.Image',
    'Body',
    'Body.Buttons',
    'Body.Button',
    'Body.Buttons.BackgroundImage',
    'Body.Button.BackgroundImage',
    'Body.Buttons.Icon',
    'Body.FeatureImage',
    'Body.TextBlocks.Image',
    'Body.TextBlock.Image',
    'Body.Icons.Image',
    'Body.Features',
    'Body.Features.Image',
    'Body.Emails',
    'Body.Items',
    'Body.DownloadButtons',
    'Body.DownloadButtons.Buttons',
    'Body.DownloadButtons.Buttons.Icon',
    'Body.DownloadButtons.Buttons.BackgroundImage',
    'Body.IconBesideTitle',
    'FeatureImage',
    'Category',
    'Authors',
    'Topic',
    'Posts',
    'Hero.Slideshows',
    'Hero.Slideshows.Images',
    'Body.Logos',
    'Body.Logos.BrandLogos',
    'Body.Logos.Icons',
    'Notice',
    'HeaderScripts',
    'GlobalMetaAttributes',
    'Body.DownloadBlocks',
    'Body.DownloadBlocks.buttons',
    'Body.DownloadBlocks.icon',
    'Body.ProductVariants',
    'Body.ProductVariants.featureImage',
  ],
}
